angular.module('filters').filter('escape', function() {
  return function(string) {
    return _.escape(string);
  };
});
